import PosthogService from '~/services/posthog/PosthogService';

export interface IEodNoThanksClickedPayload {
  professionalId: string;
}

/**
 * Fires when the user clicks "No Thanks" on the EOD Invite popup
 * Event: dental_portal:invite:EOD_no_thanks_clicked
 */
export function fireEodNoThanksClicked(payload: IEodNoThanksClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:EOD_no_thanks_clicked', {
    professional_id: payload.professionalId,
  });
}
